
import Amplify, { Auth } from 'aws-amplify';
import AwsOptions from '../../aws_config';
export default {
  init() {
    Amplify.configure({
      Auth: AwsOptions.Auth,
      API: {
        ...AwsOptions.API,
        graphql_headers: async () => {
          const session = await Auth.currentSession();
          return {
            Authorization: session.getIdToken().getJwtToken(),
          };
        },
      },
      oauth: {
        ...AwsOptions.oauth,
      },
      Storage: AwsOptions.Storage,
    });
  },
  login(data, self) {
    const context = self;
    const authenticationData = {
      Username: data.email,
      Password: data.password,
    };
    Auth.signIn(authenticationData.Username, authenticationData.Password)
      .then((user) => {
        context.$store.commit('spinner', false);
        if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
          context.$router.push({
            name: 'complete-new-password', params: {
              user,
            },
          });
        } else {
          context.$router.push({
            path: 'users/all',
          });
        }
      })
      .catch((err) => {
        context.$store.commit('spinner', false);
        if (err.message === 'User does not exist.') {
          context.userDoesNotExist = true;
        } else {
          context.errorEmailOrPassword = true;
        }
      });
  },
  forgotPassword(username, context) {
    Auth.forgotPassword(username)
      .then(() => {
        context.$store.commit('spinner', false);
        context.$router.push({
          name: 'confirm-reset-password', params: {
            email: username,
          },
        });
      })
      .catch((err) => {
        context.$store.commit('spinner', false);
        // eslint-disable-next-line
        context.errorResetPassword = err.message;
      });
  },
  confirmResetPassword(data, context) {
    // Collect confirmation code and new password, then
    Auth.forgotPasswordSubmit(data.email, data.code, data.password)
      .then(() => {
        this.login(data, context);
      })
      .catch((err) => {
        context.$store.commit('spinner', false);
        // eslint-disable-next-line
        context.errorWithCode = err.message;
      });
  },
};
